export type DlEventSource = { id: string; name: string };

export const DL_CURRENCY = 'EUR';

export enum DataLayerEnum {
  NAME_REFFER = 'NAME_REFFER',
  NAME_CHECKOUT = 'NAME_CHECKOUT',
}

export enum DlEcommerceEvents {
  ADD_TO_CART = 'add_to_cart',
  REMOVE_FROM_CART = 'remove_from_cart',
  VIEW_ITEM = 'view_item',
  SELECT_ITEM = 'select_item',
  DETAIL = 'detail',
  BEGIN_CHECKOUT = 'begin_checkout',
  PURCHASE = 'purchase',
  ADD_TO_WISHLIST = 'add_to_wishlist',
  SEARCH = 'search',
  VIEW_ITEM_LIST = 'view_item_list',
  VIEW_CART = 'view_cart',
  LOGIN = 'login',
  SIGN_UP = 'sign_up',
}

export const EventSourcesData: { [x: string]: DlEventSource } = {
  HOME: { id: 'home', name: 'Home' },
  CATEGORY: { id: 'category', name: 'Category' },
  OWN_CATEGORY: { id: 'own_category', name: 'Own category' },
  PRODUCTS_SLIDER: { id: 'products_slider', name: 'Products slider' },
  PRODUCTS_LIST: { id: 'products_list', name: 'Products list' },
  PRODUCT_PREVIEW: { id: 'product_preview', name: 'Product preview' }, // modal window
  PRODUCT_VIEW: { id: 'product_view', name: 'Product view' },
  BRAND: { id: 'brand', name: 'Brand' },
  ORGANIC_BADGE: { id: 'organic_badge', name: 'Organic badge' },
  PRODUCT_VARIANTS: { id: 'product_variants', name: 'Product variants' },
  PRODUCT_RECOMMENDATIONS: { id: 'product_recommendations', name: 'Product recommendations' },
  WISHLIST: { id: 'wishlist', name: 'Wishlist' },
  SEARCH_PREVIEW: { id: 'search_preview', name: 'Search preview' }, // popover
  SEARCH_RESULTS: { id: 'search_results', name: 'Search results' },
  ORDERS_HISTORY: { id: 'orders_history', name: 'Orders history' },
  SHOPPING_CART: { id: 'shopping_cart', name: 'Shopping cart' },
  SHOPPING_CART_PREVIEW: { id: 'shopping_cart_preview', name: 'Shopping cart preview' }, // popover
  RECENTLY_VIEWED: { id: 'recently_viewed', name: 'Recently viewed' },
};

export enum DLSignInUpEventsMethods {
  internal = 'Internal',
  google = 'Google',
  facebook = 'Facebook',
  apple = 'Apple',
}
